/* eslint-disable no-lonely-if */
import viewTransitionNavUtility from "./viewTransitionNavUtility";
import {
  addLanguageToPath,
  extractLanguageFromPath,
  isChinaDomainClient,
  shouldAddLanguagePrefix,
} from "./languageCore";

/**
 * Prefix from the URL currently in the address bar — not the language cookie and
 * not stale SSR state. Cookie mismatches on an unprefixed URL are the language
 * modal's job; silently applying the cookie here re-introduces /fr after a back
 * gesture.
 */
const getLanguageFromCurrentUrl = (): string => {
  if (typeof window === "undefined") return "en";
  return extractLanguageFromPath(window.location.pathname) || "en";
};

const customHistoryPush = (history: any, link: string, noTransition = false) => {
  const { appData }: any = window.__INITIAL_STATE__;
  const isChinaDomain = isChinaDomainClient();
  const userLanguage = isChinaDomain
    ? extractLanguageFromPath(window.location.pathname) || appData?.userLanguage || "zh"
    : getLanguageFromCurrentUrl();
  const enhancedLink =
    !isChinaDomain || shouldAddLanguagePrefix(userLanguage)
      ? addLanguageToPath(link, userLanguage)
      : link;

  if (appData.isDesktop && appData.isInternalUser) {
    window.location.href = enhancedLink;
  } else {
    if (noTransition) history.push(enhancedLink);
    else viewTransitionNavUtility(() => history.push(enhancedLink), "right-to-left");
  }
};

export default customHistoryPush;
